import { createApp, h, provide } from "vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import App from "./App.vue";
import router from "./router";
import AOS from "aos";
import "aos/dist/aos.css";
import "./assets/custom.scss";
import axios from "axios";
import { createHead } from '@unhead/vue/client'
import VueAxios from "vue-axios";
import apolloClient from "./apollo"; // Import Apollo Client

const DEV_API_URL = "https://content.meander.software/api";
const PROD_API_URL = "https://content.meander.software/api";
const BACKEND_URL = "https://backend.meander.software";
const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient); // Provide Apollo Client globally
  },
  render: () => h(App),
});
// app.provide(DefaultApolloClient, apolloClient);
app.config.globalProperties.$baseUrl =
  process.env.NODE_ENV == "production" ? PROD_API_URL : DEV_API_URL;
app.config.globalProperties.$backendUrl = BACKEND_URL;

app.use(VueAxios, axios);
const head = createHead()
app.use(head)
app.use(router).mount("#app");

// Defer AOS initialization to reduce TBT (Total Blocking Time)
if (typeof window !== 'undefined') {
  const initAOSWithDelay = () => {
    setTimeout(() => {
      if (typeof AOS !== 'undefined') {
        AOS.init({
          duration: 800,
          once: true,
          disable: 'mobile'
        });
      }
    }, 4000);
  };
  
  if (document.readyState === 'complete') {
    initAOSWithDelay();
  } else {
    window.addEventListener('load', initAOSWithDelay);
  }
}
